import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import ConstructionUpdates from './pages/ConstructionUpdates';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Disclaimer from './pages/Disclaimer';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminInquiries from './pages/AdminInquiries';
import AdminConstructionUpdates from './pages/AdminConstructionUpdates';
import AdminSEO from './pages/AdminSEO';
import AdminSocialLinks from './pages/AdminSocialLinks';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// SEO Component that fetches and applies meta tags
const SEOHead = () => {
  const [seo, setSeo] = useState(null);

  useEffect(() => {
    const fetchSEO = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/seo-settings`);
        setSeo(response.data);
      } catch (error) {
        console.error('Error fetching SEO settings:', error);
      }
    };
    fetchSEO();
  }, []);
  
  if (!seo) return null;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{seo.site_title}</title>
      <meta name="title" content={seo.site_title} />
      <meta name="description" content={seo.site_description} />
      <meta name="keywords" content={seo.site_keywords} />
      <meta name="author" content={seo.site_author} />
      <meta name="robots" content="index, follow" />

      {/* Canonical */}
      <link rel="canonical" href={seo.og_url || "https://chamgunaaangan.com"} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={seo.og_url} />
      <meta property="og:title" content={seo.og_title} />
      <meta property="og:description" content={seo.og_description} />
      <meta property="og:image" content={seo.og_image} />
      <meta property="og:site_name" content="Changuna Aangan" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content={seo.twitter_card} />
      <meta name="twitter:url" content={seo.og_url} />
      <meta name="twitter:title" content={seo.twitter_title} />
      <meta name="twitter:description" content={seo.twitter_description} />
      <meta name="twitter:image" content={seo.twitter_image} />
    </Helmet>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SEOHead />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={
            <>
              <Header />
              <Home />
              <Footer />
              <WhatsAppButton />
            </>
          } />
          <Route path="/construction-updates" element={
            <>
              <Header />
              <ConstructionUpdates />
              <Footer />
              <WhatsAppButton />
            </>
          } />
          <Route path="/privacy-policy" element={
            <>
              <Header />
              <PrivacyPolicy />
              <Footer />
            </>
          } />
          <Route path="/disclaimer" element={
            <>
              <Header />
              <Disclaimer />
              <Footer />
            </>
          } />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/inquiries" element={<AdminInquiries />} />
          <Route path="/admin/construction-updates" element={<AdminConstructionUpdates />} />
          <Route path="/admin/seo" element={<AdminSEO />} />
          <Route path="/admin/social-links" element={<AdminSocialLinks />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
